import { Component } from '@angular/core';
import { AuthLayoutComponent } from '../../_layouts/auth-layout/auth-layout.component';
import { MatCardTitle, MatCardContent} from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink} from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { UserService } from '../../../Dashboard/_services/users.service';
import { AlertService } from '../../../Dashboard/_services/alert.service';

@Component({
    selector: 'app-login',
    imports: [AuthLayoutComponent, MatCardTitle, MatCardContent, MatFormFieldModule, MatInputModule, MatIconModule, FormsModule, RouterLink],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent {
  email: string = '';
  password: string = '';
  rememberMe: boolean = true;
  showPassword: boolean = false;
  submitting: boolean = false;

  constructor(private usersService: UserService, private router: Router, private alertService: AlertService) {}

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  async onSubmit(form: NgForm) {
    if (form.invalid || this.submitting) {
      form.control.markAllAsTouched();
      return;
    }

    this.submitting = true;
    await this.usersService.loginUser(this.email.toLowerCase(), this.password).subscribe({
      next: (response) => {
        this.usersService.setLoginStatus(response, true, this.rememberMe);
        // Dispatch-only accounts (role DELIVERY, nothing else) land straight
        // on their own section rather than the default Sales page, which
        // they have no access to - see main-layout's isDeliveryOnly.
        const roles: string[] = (response?.userrole ?? '').split(',');
        const isDeliveryOnly =
          roles.includes('DELIVERY') &&
          !roles.includes('ADMIN') &&
          !roles.includes('SALES') &&
          !roles.includes('SALEADMIN') &&
          !roles.includes('S-ADMIN');
        const isPurchaseOnly =
          roles.includes('PURCHASE') &&
          !roles.includes('ADMIN') &&
          !roles.includes('SALES') &&
          !roles.includes('SALEADMIN') &&
          !roles.includes('S-ADMIN');
        const isMarketingOnly =
          roles.includes('MARKETING') &&
          !['ADMIN', 'SALES', 'SALEADMIN', 'S-ADMIN', 'DELIVERY', 'PURCHASE'].some((r) => roles.includes(r));
        this.router.navigate([
          isDeliveryOnly ? '/delivery-validation' : isPurchaseOnly ? '/purchases' : isMarketingOnly ? '/dashboard' : '/',
        ]);
        this.alertService.alert('Login success', 'success');
      },
      error: (error) => {
        this.submitting = false;
        let errorMessage = 'Something went wrong';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        }
        this.alertService.alert(errorMessage, 'error');
      }
  });
  }

}
